import { Button, Modal, TextBlock, Title } from '@skillarea/lib-frontend';

import styles from './ChestPromptModal.module.scss';

export type TChestPromptModalProps = {
  ctaLabel: string;
  description: string;
  heading: string;
  onCta: () => void;
  testId: string;
  title: string;
};

export function ChestPromptModal({
  ctaLabel,
  description,
  heading,
  onCta,
  testId,
  title,
}: TChestPromptModalProps) {
  return (
    <Modal
      classNameModal={styles.modal}
      description={description}
      size="l"
      title={title}
    >
      <div className={styles.content} data-testid={testId}>
        <div className={styles.centered}>
          <Title className={styles.title} color="contrast" size="l">
            {heading}
          </Title>

          <TextBlock className={styles.text} color="contrast" size="m">
            {description}
          </TextBlock>
        </div>

        <Button
          className={styles.action}
          color="accent"
          onClick={onCta}
          size="s"
          type="button"
          variant="filled"
        >
          {ctaLabel}
        </Button>
      </div>
    </Modal>
  );
}
